var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8105 13.0001L13.417 5.39356L12.3565 4.33306L4.75 11.9396V13.0001H5.8105ZM6.43225 14.5001H3.25V11.3178L11.8263 2.74156C11.9669 2.60096 12.1576 2.52197 12.3565 2.52197C12.5554 2.52197 12.7461 2.60096 12.8868 2.74156L15.0085 4.86331C15.1491 5.00396 15.2281 5.19469 15.2281 5.39356C15.2281 5.59244 15.1491 5.78317 15.0085 5.92381L6.43225 14.5001ZM3.25 16.0001H16.75V17.5001H3.25V16.0001Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDark);
export default __webpack_public_path__ + "static/media/edit-dark.089fcb403d234cab017e0328af0a869a.svg";
export { ForwardRef as ReactComponent };